import { createFileRoute } from "@tanstack/react-router";

import { SocialPublishing } from "@/features/social-publishing";
import { usePageTitle } from "@/hooks/usePageTitle";
import { requireSocialPublishingFeatureFlag } from "@/lib/posthog-flags";

export const Route = createFileRoute("/_auth/_app-shell/publish/posts/$postId")(
  { beforeLoad: requireSocialPublishingFeatureFlag, component: RouteComponent },
);

function RouteComponent() {
  usePageTitle("Post insights");
  const { postId } = Route.useParams();

  return <SocialPublishing postId={Number(postId)} tab="insights" />;
}
